import { Flex, IconButton, Text } from "@chakra-ui/react";
import { useRef, useState } from "react";
import { IoPlayCircleSharp } from "react-icons/io5";
import { QuizExample } from "../../services/guides/types";

import { logger } from "../../utils/logger";
import ReadButton from "components/read-button";
import { useRouter } from 'next/router';

interface Props {
  id: string;
  example: QuizExample;
  voice?: SpeechSynthesisVoice;
}

export default function AudioSample(props: Props) {
  const router = useRouter();

  const [isReading, setIsReading] = useState(false);
  const readingTimer = useRef<NodeJS.Timeout | null>(null);
  const currentPath = router.pathname; 
  const targetPath = "/app/guide/";

  const onClick = (shouldRead: boolean) => {
    if (shouldRead && props.voice) {
      const utterThis = new SpeechSynthesisUtterance(props.example.text);

      utterThis.volume = 1;
      utterThis.voice = props.voice;
      utterThis.rate = 0.7;
      utterThis.lang = props.voice.lang;

      utterThis.addEventListener("start", () => {
        setIsReading(true);
      });

      utterThis.addEventListener("end", function () {
        clearTimeout(readingTimer.current!);
        setIsReading(false);
      });

      utterThis.addEventListener("error", (err) => {
        logger.error(err.name);
      });

      window.speechSynthesis.speak(utterThis);

      readingTimer.current = setTimeout(() => {
        logger.warn("Reading timed out");
        window.speechSynthesis.cancel();
        setIsReading(false);
      }, 2000 + props.example.text.length * 250);
    }
  };

  return (
    <Flex mt={1} alignItems="center" id={props.id}>
      <>
        <Text fontSize={"sm"} mr={2}>
          {props.example.text}
        </Text>

        <Text fontSize={"sm"}>({props.example.translation})</Text>
      </>
      {props.voice && !currentPath.includes(targetPath) && (
        <IconButton
          aria-label="Play"
          size={"sm"}
          h={"23px"}
          fontSize="20px"
          icon={<IoPlayCircleSharp />}
          variant="transparent"
          onClick={() => onClick(!isReading)}
          isLoading={isReading}
        />
      )}
      {currentPath.includes(targetPath) && (
        <ReadButton
          message={{
            role: "assistant",
            id: props.example.text,
            content: props.example.text,
          }}
          fontSize={{ base: "20px", md: "20px" }}
          textColor={"white"}
        />
      )}
    </Flex>
  );
}
